/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Cst {
  constructor () {
    this.cst_id = uuidV4();
    this.cst_icms_id = '';
    this.cst_icms_id_referente = ''
  }
}
